import React, { useImperativeHandle, forwardRef, useRef, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import uuid from 'react-uuid';
import { Modal } from 'bootstrap';
import HttpAPICall from '../../services/HttpAPICall';
import { IAM_API_BASE_URL_2 } from '../../services/TapApiUrls';
import TapIcon from '../../services/TapIcon';
import TapSelect from '../../components/ui/TapSelect';
import Loader from '../../components/ui/Loader/Loader';
import AdditionalAttributeForm from '../includes/ui/AdditionalAttributeForm';
import ApplicationLayout from '../../layouts/ApplicationLayout';


const ProjectEdit = forwardRef((props, ref) => {
  const projectFormDataUrl        =   IAM_API_BASE_URL_2 + '/project_structure/form_data'; 
    const projectEditUrl            =   IAM_API_BASE_URL_2 + '/project/edit';
    const access_token                      =   useSelector(state => state.auth.access_token);

    const initialData                       =   {
        id                  :   '',
        name                :   '',
        category_id         :   '',
        notes               :   '',
        reason_for_delay    :   ''
    }

    const [formDataLoading, setFormDataLoading] =   useState(false);
    const [categories, setCategories]           =   useState([]);
    const [formSubmitting, setFormSubmitting]   =   useState(false);
    const [editData, setEditData]               =   useState(initialData);
    const [formAdditionalData, setFormAdditionalData]               =   useState([]);

    const initialDataHandler = (projectDetails) => {
        let updateFormState = [];
        if (projectDetails?.additional_attr) {
            projectDetails.additional_attr.map((i, k) => {
                let name = "additional_attributes_" + i.key;
                updateFormState[name] = i.value;
            });
        }
        if (projectDetails) {
            setEditData({
                id: projectDetails.id,
                name: projectDetails.name,
                category_id: projectDetails.category ? projectDetails.category.id : '',
                notes: projectDetails.notes,
                reason_for_delay:projectDetails.reason_for_delay,
                ...updateFormState
            });
            formData();
        }

    }
    const closeEvent = () => {
        const data = props?.location?.state?.projectDetailsData
        props.history.push({ pathname: `/project/` + data?.id })
    }
    useEffect(() => {
        const data = props?.location?.state?.projectDetailsData
        initialDataHandler(data)
    }, [])
    const formData = () => {
        setFormDataLoading(true);
        HttpAPICall.withAthorization('GET', projectFormDataUrl, access_token, null, null, (response) => {
            const categories = response.data.categories.map(c => ({ label: c.name, value: c.id }));
            setCategories(categories)
            setFormAdditionalData(response.data)
        })
            .then(() => setFormDataLoading(pre => !pre))
    }
    const handleOnChange = (e) => {
        setEditData(pre => ({ ...pre, [e.target.name]: e.target.value }))
    }

    const submitHandler = (e) => {
        e.preventDefault();

        const form = { ...editData };
        let additional_attributes = {};
        formAdditionalData?.additional_attributes.forEach(attr => {
            const key = attr.key;
            const fieldName = "additional_attributes_" + key;
            additional_attributes[key] = form[fieldName] || "";
            delete form[fieldName];
        });
        const payload = {
            ...form,
            additional_attributes
        };
        if (editData.id) {
            setFormSubmitting(true)
            HttpAPICall.withAthorization('PUT', projectEditUrl, access_token, null, payload, (response) => {
                toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                closeEvent()
            })
                .then(() => setFormSubmitting(pre => !pre))

        } else {
            toast.error('Something went wrong. You cannot edit the project.')
        }

    }

    return <>
        <ApplicationLayout>
            <Helmet><title>Project Edit</title></Helmet>
            <div className="page_title row m0">
                <div className="col-12">
                    <h3>Edit Project</h3>
                    <div className="text-end mt15">
                        <button onClick={closeEvent} type="button" className="btn btn-secondary">
                            <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="Close " />
                        </button>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="col-12 pl4"
                        style={{ overflowY: "auto", height: "calc(100vh - 130px)", padding: "0px", backgroundColor: "white" }}>
                        {formDataLoading
                            ? <Loader />
                            :
                            <>
                                <form id="editProject" onSubmit={submitHandler} className="bg-white p-3">
                                    <div className="row align-items-center">
                                        <div className="col-3">
                                            <label htmlFor="name" className="form-label require">Name</label>
                                        </div>
                                        <div className="col-sm-8">
                                            <input
                                                name="name"
                                                type="text"
                                                className="form-control"
                                                autoComplete="off"
                                                value={editData.name}
                                                onChange={handleOnChange}
                                                placeholder="Enter Name"
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="row align-items-center mt-2">
                                        <div className="col-3">
                                            <label htmlFor="name" className="form-label require">Category</label>
                                        </div>
                                        <div className="col-sm-8 mb-2">
                                            <TapSelect
                                                options={categories}
                                                isSearchable={true}
                                                isClearable={true}
                                                // isDisabled={true}
                                                value={categories.find(c => c.value === editData.category_id)}
                                                changeEvent={(selectedOption) => {
                                                    if (selectedOption?.value) {
                                                        setEditData(pre => ({ ...pre, category_id: selectedOption ? selectedOption?.value : "" }))
                                                    } else {
                                                        setEditData(pre => ({ ...pre, category_id: '' }))
                                                    }
                                                }}
                                                placeholder="Select Category"
                                            />
                                        </div>
                                    </div>
                                    <div className="row align-items-center">
                                        <div className="col-3">
                                            <label htmlFor="reason_for_delay" className="form-label ">Reason For Delay</label>
                                        </div>
                                        <div className="col-sm-8">
                                            <input
                                                name="reason_for_delay"
                                                type="text"
                                                className="form-control"
                                                autoComplete="off"
                                                value={editData.reason_for_delay}
                                                onChange={handleOnChange}
                                                placeholder="Enter Reason For Delay"
                                            />
                                        </div>
                                    </div>
                                    <div className='ps1'>
                                        {formAdditionalData &&
                                            formAdditionalData.additional_attributes &&
                                            formAdditionalData.additional_attributes.length > 0 && (
                                                <AdditionalAttributeForm
                                                    additionalAttributes={formAdditionalData.additional_attributes}
                                                    formState={editData}
                                                    onAttributeChange={(value, attributeName) => {
                                                        setEditData({
                                                            ...editData,
                                                            [attributeName]: value,
                                                        })
                                                    }}
                                                    colSpan={"col-sm-8"}
                                                />
                                            )}
                                    </div>

                                    <div className="row align-items-center ">
                                        <div className="col-3">
                                            <label htmlFor="name" className="form-label require">Notes</label>
                                        </div>
                                        <div className="col-sm-8">
                                            <textarea
                                                name="notes"
                                                type="text"
                                                className="form-control"
                                                autoComplete="off"
                                                value={editData.notes}
                                                onChange={handleOnChange}
                                                placeholder="Enter Notes..."
                                            />
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 justify-content-end me-5 mt-5">
                                        <button onClick={closeEvent} type="button" className="btn btn-secondary">
                                            Close </button>
                                        <button type="submit" form='editProject' className="btn btn-primary me-5" disabled={formSubmitting || formDataLoading} >Save {formSubmitting && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                                    </div>
                                </form>
                            </>
                        }
                    </div>
                </div>
            </div>
        </ApplicationLayout>
    </>
});

export default ProjectEdit;

